import * as React from 'react';
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import Quote from "@system/config/quote";
import System from "../../../helper/system";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const AddedToQuoteBomPopup = (props) => {
    const [status, SetStatus] = useState(false);
    const [quoteData, SetQuoteData] = useState([]);

    const [{ AddedToQuoteBomPopup }, {}, {}] = useDOMAttachToSystemStore();
    useEffect(() => {
        if (AddedToQuoteBomPopup) {
            SetQuoteData(AddedToQuoteBomPopup && AddedToQuoteBomPopup.data && AddedToQuoteBomPopup.data.quoteData)
            SetStatus(true)
        }
    }, [AddedToQuoteBomPopup]);
    const onHide = (action = true) => {
        SetStatus(false)
    };
    
    return (
        <>
            <Modal show={status} onHide={() => {
                onHide()
            }}>
                <div className="avnet-modal modal-800">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×</button>
                        <div className="bs5 modal-header border-0">
                            <h3 className="modal-title m-auto" id="exampleModalLabel">Request a Quote</h3>
                        </div>
                        <div className="modal-body">
                            {
                                quoteData !== undefined && quoteData.length > 0 &&
                                <>
                                    <div className="alert alert-success alert-dismissible">
                                        <span>You've added a part to your open quote.</span>
                                        <a href={void (0)} className="close" data-dismiss="alert" aria-label="close">&times;</a>
                                    </div>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Part Number/Manufacturer  </th>
                                                <th>Quantity </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {quoteData.map(v => (
                                                <>
                                                    {
                                                        v.quantity1 !== undefined &&
                                                        v.quantity1 > 0 &&
                                                        <tr>
                                                            <td rowSpan="3">{v.partNumber} <br />
                                                                By {v.manufacturerCode}</td>
                                                            <td>{v.quantity1} </td>
                                                        </tr>
                                                    }
                                                    <tr>
                                                        <td>——</td>
                                                    </tr>


                                                    <tr>
                                                        <td>——</td>
                                                    </tr>
                                                </>
                                            ))
                                            }
                                        </tbody>
                                    </table>
                                    <div className="text-center">
                                        <b className="d-block">You will still need to submit the quote in order to receive a response.</b>
                                        Review your quotes details by clicking the green button below or continue
                                        shopping and return to the open quote when ready.
                                    </div>
                                </>
                            }

                        </div>
                        <div className="modal-footer d-flex justify-content-center">
                            <button type="button" className="bs5 btn btn-secondary"
                                onClick={() => {
                                    window.location.href = System.getHomepageUrl()
                                }}>Continue Shopping</button>
                            <button type="button" className="bs5 btn btn-primary"
                                onClick={() => {
                                    window.location.href = Quote.getQuoteRouteURL()
                                }}>Review Quote</button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default AddedToQuoteBomPopup;